import { CITIES_DB, COUNTRIES_DB, STATES_DB } from "modules/api/endpoint";

export const getCountries = async (): Promise<any> => {
  const countries = await fetch(COUNTRIES_DB);

  return countries.json();
};

export const getStates = async (): Promise<any> => {
  const states = await fetch(STATES_DB);

  return states.json();
};

export const getCities = async (): Promise<any> => {
  const cities = await fetch(CITIES_DB);

  return cities.json();
};

export const getPageTitle = (path: string) => {
  let title = "";
  if (path === "/staffs") title = "Staff Accounts";
  else if (path === "/members-working-out") title = "Members Working Out";
  else if (path === "/members") title = "Members";
  else if (path === "/message-center") title = "Messages";
  else if (path.includes("/reports/")) title = "Reports";
  else if (path.includes("/workout-templates")) title = "Workout Templates";
  else if (path.includes("/groups/")) title = "Groups";
  else if (path.includes("/groups/")) title = "Groups";
  else if (path === "/interests") title = "Interests";
  else if (path === "/member-tasks") title = "Member Tasks";

  return {
    shouldUpdate: !!title,
    title,
  };
};

export default {
  getCities,
  getCountries,
  getPageTitle,
  getStates,
};
